import styled from 'styled-components';
import { useAppSelector } from '../../buildStore';
import { getIsVoiceInputRecording, getIsVoiceInputTranscribing, getIsVoiceInputPermissionError, getIsVoiceInputTranscribeError } from '../selectors/voiceInputSelectors';
import VoiceInputWaveform from './VoiceInputWaveform';
import VoiceTranscribingBar from './VoiceTranscribingBar';
import VoiceRecordingControls from './VoiceRecordingControls';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Bar = styled.div.withConfig({
  displayName: "VoiceRecordingBar__Bar"
})(["display:flex;align-items:center;gap:8px;width:100%;min-width:0;"]);
const ErrorText = styled.span.withConfig({
  displayName: "VoiceRecordingBar__ErrorText"
})(["flex:1;min-width:0;font-size:14px;line-height:20px;color:#d94c53;"]);
function getRecordingFeedback(isRecording, isTranscribing, isPermissionError, isTranscribeError) {
  if (isRecording) return /*#__PURE__*/_jsx(VoiceInputWaveform, {});
  if (isTranscribing) return /*#__PURE__*/_jsx(VoiceTranscribingBar, {});
  if (isPermissionError) {
    return /*#__PURE__*/_jsx(ErrorText, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-visitor-ui.voiceInput.micPermissionDenied"
      })
    });
  }
  if (isTranscribeError) {
    return /*#__PURE__*/_jsx(ErrorText, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-visitor-ui.voiceInput.errorTranscribing"
      })
    });
  }
  return null;
}
const VoiceRecordingBar = () => {
  const isRecording = useAppSelector(getIsVoiceInputRecording);
  const isTranscribing = useAppSelector(getIsVoiceInputTranscribing);
  const isPermissionError = useAppSelector(getIsVoiceInputPermissionError);
  const isTranscribeError = useAppSelector(getIsVoiceInputTranscribeError);
  return /*#__PURE__*/_jsxs(Bar, {
    children: [getRecordingFeedback(isRecording, isTranscribing, isPermissionError, isTranscribeError), /*#__PURE__*/_jsx(VoiceRecordingControls, {
      discardDisabled: isTranscribing,
      confirmDisabled: isTranscribing || isTranscribeError || isPermissionError,
      hideConfirm: isPermissionError
    })]
  });
};
VoiceRecordingBar.displayName = 'VoiceRecordingBar';
export default VoiceRecordingBar;